import { TemplateActionTypes } from "./template.type";

export const templateData = ( showtemplate)=> ({
    type : TemplateActionTypes.SET_TEMPLATE_DATA,
    payload: {
       
        showtemplate
    
      }
  })